import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { SESSION_EXPIRED_KEY } from '../../utils/authToken';
import { parseApiError } from '../../utils/apiError';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // Пришли сюда, потому что сессия истекла — показываем пояснение один раз
  const [sessionExpired] = useState(() => sessionStorage.getItem(SESSION_EXPIRED_KEY) === '1');
  useEffect(() => {
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  // Пришли со страницы регистрации после подтверждения почты
  const justRegistered = (location.state as { registered?: boolean } | null)?.registered === true;
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const loggedIn = await login(email, password);
      if (loggedIn.mustChangePassword) {
        // Вход по временному паролю из письма — предлагаем сразу задать свой
        navigate('/change-password', { state: { forced: true } });
      } else {
        // Возвращаем туда, откуда пришли (например, на страницу турнира), иначе на главную
        const from = (location.state as { from?: { pathname?: string; search?: string } } | null)?.from;
        navigate(from?.pathname ? `${from.pathname}${from.search ?? ''}` : '/');
      }
    } catch (err) {
      const apiError = parseApiError(err);
      // 429 — слишком много попыток: сервер сообщает, через сколько можно повторить
      setError(apiError.status === 429 && apiError.message
        ? apiError.message
        : 'Ошибка входа. Проверьте email и пароль.');
    }
  };

  return (
    <div className="login-page">
      <h2>Вход в систему</h2>
      {sessionExpired && !error && (
        <div className="auth-page__notice">Сессия истекла. Войдите заново.</div>
      )}
      {justRegistered && !error && (
        <div className="auth-page__success">Почта подтверждена, регистрация завершена. Теперь можно войти.</div>
      )}
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Пароль:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        
        <div className="form-actions">
          <button type="submit" className="btn">Войти</button>
        </div>
      </form>
      
      <div className="register-link">
        <p>Нет аккаунта? <Link to="/register">Зарегистрироваться</Link></p>
        <p><Link to="/forgot-password">Забыли пароль?</Link></p>
      </div>
    </div>
  );
};

export default Login;
